import { useUserLocation } from '../../hooks/useUserLocation';
import { BankingCurrency } from '../../types/banking';
import { formatNumericValue } from '../../utils/common';
import Typography from '../Typography';
import { TypographyProps } from '@mui/material';

type NumericTextProps = TypographyProps & {
  children: string | number;
  digits?: number;
  currency?: BankingCurrency;
};

const NumericText = ({ children, digits = 2, currency, ...rest }: NumericTextProps) => {
  const { language } = useUserLocation();
  const numericValue = Number(children);

  if (isNaN(numericValue)) return null;

  const value = formatNumericValue(numericValue, digits, language);

  return (
    <Typography {...rest}>
      {value}
      {currency && ` ${currency}`}
    </Typography>
  );
};

export default NumericText;
